<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="configuration()?.title"
      [canGoBack]="true"
      [customBack]="backPage"
      id="top-nav-height" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  @if (!isRightSideContent && !windowService.isDesktopRes && loaded) {
    <div class="book-job-sticky-header">
      <tidy-wrapper>
        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-top: 5px;">
          <div>
            <tidy-row class="vertical-align-center">
              <tidy-image
                class="body-size"
                [src]="'assets/img/icons/number_1_white.svg'" />
              <tidy-text
                [body]="serviceFrequencyLabelSignal() | titlecase" />
            </tidy-row>
            <tidy-row class="vertical-align-center">
              <tidy-image
                class="body-size"
                [src]="'assets/img/icons/number_2_white.svg'" />
              <tidy-text
                [body]="dateLabel" />
            </tidy-row>
            @if ((form?.value?.frequency === 'twice_a_week' || form?.value?.frequency === 'thrice_a_week') && secondDateLabel) {
              <tidy-row class="vertical-align-center">
                <tidy-image
                  class="body-size"
                  [src]="'assets/img/icons/number_3_white.svg'" />
                <tidy-text
                  [body]="secondDateLabel" />
              </tidy-row>
            }
            @if (form?.value?.frequency === 'thrice_a_week' && thirdDateLabel) {
              <tidy-row class="vertical-align-center">
                <tidy-image
                  class="body-size"
                  [src]="'assets/img/icons/number_4_white.svg'" />
                <tidy-text
                  [body]="thirdDateLabel" />
              </tidy-row>
            }
          </div>
          <div>
            @if (selectedDuration && selectedServiceData()) {
              <tidy-row class="extra-left-padding">
                @if (selectedServiceData()?.billingType !== 'price_later' && selectedServiceData()?.billingType !== 'hourly') {
                  <tidy-text
                    [title]="displayPrice()"
                    class="text-price custom-text-price" />
                }
                @if (selectedServiceData()?.billingType == 'hourly' || selectedServiceData()?.billingType == 'price_later') {
                  <tidy-text
                    [header]="displayPrice()"
                    class="text-price custom-text-price" />
                }
              </tidy-row>
            }
          </div>
        </div>
        <tidy-button
          [text]="configuration()?.confirm_button_text"
          [action]="boundConfirmBooking"
          [disabled]="form.invalid"
          class="primary full-width" />
        @if (hasBookingFormError) {
          <tidy-row [align]="'center'">
            <tidy-error-message
              [text]="'Please fill out all required fields.'" />
          </tidy-row>
        }
        @if (showSavingsText) {
          <tidy-row style="margin-top: -5px" [align]="'center'">
            <tidy-text
              [smallBody]="savingsText()"
              class="white" />
          </tidy-row>
        }
      </tidy-wrapper>
    </div>
  }
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-extra-bottom-padding' : ''">
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (!loaded && errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (loaded) {
      @if (pros && flowType !== 'private' && filteredProsRatingsOptions?.length > 1) {
        <tidy-row>
          <form [formGroup]="form" novalidate action="#">
            <tidy-filter
              formControlName="proOption"
              [items]="filteredProsRatingsOptions"
              [fitContent]="true"
              [newValue]="newValue"
              (optionChange)="changeFilter($event)"
              class="align-center" />
          </form>
        </tidy-row>
      }
      @if (prosRatingsOptions?.length == 4 && waterfallSettings?.key == 'never_use_tidy') {
        <tidy-alert>
          <tidy-row class="extra-bottom-padding vertical-align-center">
            <tidy-image
              [src]="'assets/img/alert.svg'"
              class="header-size" />
            <tidy-text
              [header]="'Unable to Book'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [body]="'You don\'t allow new pros and haven\'t added any of your new pros. Please enable TIDY Find New Pros or add your own pros to book.'" />
          </tidy-row>
          <tidy-row>
            <tidy-button
              [text]="'Allow TIDY Find New Pros'"
              [action]="boundTurnOnTidyFindNewPros"
              class="primary full-width" />
          </tidy-row>
          <tidy-row>
            <tidy-button
              [text]="'Add Pros'"
              [action]="boundGoToAddPro"
              class="secondary full-width" />
          </tidy-row>
        </tidy-alert>
      }
      @if (prosRatingsOptions?.length > 4 && !proSelected() && waterfallSettings?.key == 'never_use_tidy') {
        <tidy-alert>
          <tidy-row class="extra-bottom-padding vertical-align-center">
            <tidy-image
              [src]="'assets/img/alert.svg'"
              class="header-size" />
            <tidy-text
              [header]="'Unable to Book'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [body]="'You don\'t allow new pros. Please enable TIDY Find New Pros to book a new pro.'" />
          </tidy-row>
          <tidy-row>
            <tidy-button
              [text]="'Allow TIDY Find New Pros'"
              [action]="boundTurnOnTidyFindNewPros"
              class="primary full-width" />
          </tidy-row>
        </tidy-alert>
      }
      @if (showCategoryChooser) {
        <tidy-row class="extra-bottom-padding">
          <tidy-text [title]="'Select Service'" /><br>
          @if (!address?.address_name) {
            <tidy-text [body]="'For'" style="margin-right: 4px" />
            <tidy-text [body]="address?.address1" [translate]="false" />
            <tidy-text
              [body]="address?.address2 !== null ? ' ' + address?.address2 : ''"
              [translate]="false" />
          }
          @if (address?.address_name) {
            <tidy-text [body]="'For'" style="margin-right: 4px" />
            <tidy-text [body]="address?.address_name" [translate]="false" />
          }
        </tidy-row>
      }
      @if (showCategoryChooser && collapsableChooser && choseCategory() && selectedSubcategory) {
        <tidy-card class="chosen-subcategory-card">
          <tidy-card-button [hideArrow]="true" class="normal-cursor">
            <tidy-row>
              <tidy-radio-button
                class="radio-card-title"
                [ngModel]="selectedSubcategory.apiKey"
                [ngModelOptions]="{standalone: true}"
                [items]="[{value: selectedSubcategory.apiKey, viewValue: selectedSubcategory.name}]" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
        <tidy-row [align]="'center'" class="extra-bottom-padding">
          <tidy-text (action)="changeCategory()" [body]="'Change Service'" class="white-link" />
        </tidy-row>
      }
      @if (showCategoryChooser && (!choseCategory() || !collapsableChooser)) {
        <div [class.category-mode-compact]="!windowService.isDesktopRes">
          <div class="category-tab-bar-wrapper">
            @if (showTabLeftArrow) {
              <div class="category-tab-arrow category-tab-arrow-left" (click)="scrollTabBarLeft()">
                <img src="assets/svg/chevron-back-outline.svg" class="category-tab-arrow-icon" />
              </div>
            }
            <div class="category-tab-bar" #categoryTabBar (scroll)="onTabBarScroll()">
              @for (cat of filteredMainCategories; track cat.id) {
                <div
                  class="category-tab"
                  [class.category-tab-active]="selectedMainCategory?.id === cat.id"
                  (click)="selectMainCategory(cat)">
                  <img [src]="cat.icon" class="category-tab-icon" />
                  <tidy-text [helper]="cat.name" />
                </div>
              }
            </div>
            @if (showTabRightArrow) {
              <div class="category-tab-arrow category-tab-arrow-right" (click)="scrollTabBarRight()">
                <img src="assets/svg/chevron-forward-outline.svg" class="category-tab-arrow-icon" />
              </div>
            }
          </div>
        </div>
        <div [class.category-mode-compact]="!windowService.isDesktopRes">
          <div class="subcategory-grid">
            @for (sub of filteredSubcategories; track sub.apiKey) {
              <tidy-card
                class="subcategory-card small-padding"
                (click)="selectSubcategory(sub)">
                <div class="subcategory-card-inner">
                  <tidy-radio-button
                    class="radio-card-title subcategory-radio"
                    [ngModel]="selectedSubcategory?.apiKey"
                    [ngModelOptions]="{standalone: true}"
                    [items]="[{value: sub.apiKey, viewValue: sub.name}]" />
                  @if (sub.popular) {
                    <span class="popular-tag">Popular</span>
                  }
                </div>
              </tidy-card>
            }
          </div>
        </div>
      }
      @if (showCategoryChooser) {
        <tidy-row class="extra-bottom-padding">
          <tidy-text [title]="'Service Detail'" />
        </tidy-row>
        @if (!choseCategory()) {
          <tidy-alert>
            <tidy-row [align]="'center'">
              <tidy-text [body]="'Select service to add detail.'" />
            </tidy-row>
          </tidy-alert>
          <tidy-row class="extra-bottom-padding">
            <tidy-text [title]="'Select Time'" />
          </tidy-row>
          <tidy-alert>
            <tidy-row [align]="'center'">
              <tidy-text [body]="notChoseServiceSentence" />
            </tidy-row>
          </tidy-alert>
        }
      }
      @if ((!showCategoryChooser || choseCategory()) && !(prosRatingsOptions?.length == 4 && waterfallSettings?.key == 'never_use_tidy') && !(prosRatingsOptions?.length > 4 && !proSelected() && waterfallSettings?.key == 'never_use_tidy')) {
        <tidy-row class="extra-bottom-padding">
          @if (!showCategoryChooser) {
            <tidy-text
              [title]="'Select Service'" /><br>
          }
          <tidy-error-message
            [text]="errorMessage" />
          @if (!showCategoryChooser) {
            @if (!address?.address_name) {
              <tidy-text
                [body]="'For'"
                style="margin-right: 4px" />
              <tidy-text
                [body]="address?.address1"
                [translate]="false" />
              <tidy-text
                [body]="address?.address2 !== null ? ' ' + address?.address2 : ''"
                [translate]="false" />
            }
            @if (address?.address_name) {
              <tidy-text
                [body]="'For'"
                style="margin-right: 4px"/>
              <tidy-text
                [body]="address?.address_name"
                [translate]="false" />
            }
          }
          @if (flowType === 'private') {
            <tidy-text
              [body]="' with '" />
            <tidy-text
              [body]="proName | titlecase"
              [translate]="false" />
            <tidy-text
              [body]="' from '" />
            <tidy-text
              [body]="proTeamName | titlecase"
              [translate]="false" />
          }
        </tidy-row>
        @if (customFlowName) {
          <tidy-alert style="padding: 15px 15px 15px 5px">
            <tidy-grid>
              <tidy-row>
                <ion-row>
                  <ion-col size="2" class="vertical-align-center">
                    <div style="margin:auto">
                      <tidy-image
                        [src]="customFlowSmallImage"
                        style="width: 50px; margin: auto" />
                    </div>
                  </ion-col>
                  <ion-col>
                    <div style="margin-left: 5px; margin-top: 5px">
                      <tidy-text
                        [body]="customFlowName" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="'offers a'" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="customFlowDiscount" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="'% discount on all cleanings.'" />
                    </div>
                  </ion-col>
                </ion-row>
              </tidy-row>
            </tidy-grid>
          </tidy-alert>
        }
        @if (isLoadingServiceDetail() || isLoadingBookingForms) {
          <tidy-row [align]="'center'">
            <tidy-loader />
          </tidy-row>
        }
        @if (!isLoadingServiceDetail() && ownProOffersNoneOfType()) {
          <tidy-alert>
            <tidy-row [class]="canSeeOtherPros ? 'extra-bottom-padding' : ''">
              <tidy-text
                [body]="selectedPro?.viewValue + (' does not offer this service.' | translate)"
                [translate]="false" />
            </tidy-row>
            @if (canSeeOtherPros) {
              <tidy-row>
                <tidy-text
                  [actionBody]="'See other pros'"
                  (action)="seeOtherProsForService()"
                  class="link" />
              </tidy-row>
            }
          </tidy-alert>
        }
        @if (!isLoadingServiceDetail() && !isLoadingBookingForms && (!showCategoryChooser || categoryId === 1)) {
        @for (service of services(); track service; let i = $index) {
          @if (showService(service)) {
            <tidy-card>
              <tidy-card-button (action)="handleServiceClick(service)" [hideArrow]="true">
                <tidy-row>
                  <tidy-row class="vertical-align-center">
                    <form [formGroup]="form" novalidate action="#">
                      <tidy-radio-button
                        formControlName="service"
                        class="radio-card-title"
                        [form]="form.controls.service"
                        [items]="[{value: service.key, viewValue: service.title | titlecase}]" />
                    </form>
                    @if (service.title?.toLowerCase()?.includes('2.5')) {
                      <span
                        class="service-popular-tag"
                        [class.service-popular-tag-selected]="form.value.service === service.key">POPULAR</span>
                    }
                  </tidy-row>
                  @if (!showCategoryChooser || categoryId === 1) {
                    <tidy-row>
                      <tidy-text
                        [body]="displayPriceMap().get(service)" />
                      <tidy-text
                        [body]="service.description" />
                    </tidy-row>
                  }
                </tidy-row>
                @if ((!showCategoryChooser || categoryId === 1) && form.value.service === service.key && !configuration()?.hide_frequency && !isLoggingJob) {
                  <tidy-row>
                    <tidy-divider />
                  </tidy-row>
                  <tidy-row class="no-padding">
                    <form [formGroup]="form" novalidate action="#">
                      @if (!selectedPrivatePro()) {
                        <tidy-radio-button
                          [hideItemValues]="['every_day', 'thrice_a_week', 'twice_a_week']"
                          chunkSize="2"
                          formControlName="frequency"
                          (optionChange)="selectFrequency($event)"
                          [form]="form.controls.frequency"
                          [items]="service.frequencies"
                          (showAllOptions)="showAllFrequencies()"
                          [ordenation]="frequencyOrder"
                          [sameRow]="true" />
                      }
                      @if (selectedPrivatePro()) {
                        <tidy-radio-button
                          [hideItemValues]="['every_day']"
                          chunkSize="2"
                          formControlName="frequency"
                          (optionChange)="selectFrequency($event)"
                          [form]="form.controls.frequency"
                          [items]="service.frequencies"
                          [sameRow]="true" />
                      }
                    </form>
                  </tidy-row>
                }
                @if (selectedServiceData() === service && !selectedPrivatePro()) {
                  @if (showSavingsText) {
                    <div style="background: rgba(0, 170, 186, 0.8); margin-top: 10px; padding: 10px 5px 10px 5px; margin-left: -10px; margin-right: -10px; margin-bottom: -10px; border-radius: 0 0 5px 5px;">
                      <tidy-row [align]="'center'" class="vertical-align-center">
                        @if (savingsText()?.includes('coupon')) {
                          <tidy-image
                            [src]="'assets/img/discount.svg'"
                            class="body-size" />
                          <tidy-text
                            [actionBody]="'Coupon: checkout today to save $10!'"
                            class="white" />
                        } @else {
                          <tidy-text
                            [actionBody]="savingsText()"
                            class="white" />
                        }
                      </tidy-row>
                      @if (isUpdatingSubscription) {
                        <tidy-row [align]="'center'">
                          <tidy-text
                            (action)="updateSubscription(this)"
                            [actionBody]="'Remove Subscription'"
                            class="white link" />
                        </tidy-row>
                      }
                    </div>
                  }
                  @if (selectedFrequency() == 'One Time' && choseFrequency() && subscriptionExperiment() == 'showInlineSubscriptionSales' && !hasNonTrialPaidSubscription()) {
                    <div style="background: rgba(0, 170, 186, 0.8); margin-top: 10px; padding: 10px 5px 10px 5px; margin-left: -10px; margin-right: -10px; margin-bottom: -10px; border-radius: 0 0 5px 5px;">
                      <tidy-row [align]="'center'" class="extra-bottom-padding">
                        <tidy-text
                          [header]="'Upgrade to TIDY+ & Save 20%'"
                          class="white" />
                      </tidy-row>
                      <tidy-row [align]="'center'" class="extra-bottom-padding">
                        <tidy-text
                          [actionBody]="'TIDY+ lets you save 20% booking per property per year, cancel anytime.'"
                          class="white" />
                      </tidy-row>
                      <tidy-row [align]="'center'">
                        <tidy-text
                          [actionBody]="service.price | tcurrency"
                          class="white" /><span>&nbsp;</span>
                        <tidy-text
                          [actionBody]="'for job (save 20%)'"
                          class="white" /><br>
                        <tidy-text
                          [actionBody]="'$36 for 1 year TIDY+'"
                          class="white" />
                      </tidy-row>
                      <tidy-row>
                        <tidy-divider style="background: white; width: 150px; margin: auto" />
                      </tidy-row>
                      <tidy-row [align]="'center'" class="extra-bottom-padding">
                        <tidy-text
                          [actionBody]="(service.price + tidyPlusSubscription?.amount) | tcurrency"
                          class="white" /><span>&nbsp;</span>
                        <tidy-text
                          [actionBody]="'total today'"
                          class="white" />
                      </tidy-row>
                      <tidy-row [align]="'center'" class="extra-top-padding vertical-align-center">
                        <tidy-image
                          [src]="'assets/img/discount.svg'"
                          class="header-size" />
                        <tidy-text
                          (click)="updateSubscription(this)"
                          [largeBody]="isUpdatingSubscription ? 'Remove TIDY+' : 'Add TIDY+'"
                          class="white link"
                          style="cursor: pointer" />
                      </tidy-row>
                      <tidy-row [align]="'center'" class="extra-top-padding">
                        <tidy-text
                          (click)="goToViewSubscriptions(this)"
                          [actionBody]="'View Other Subscription Types'"
                          class="white link"
                          style="cursor: pointer" />
                      </tidy-row>
                    </div>
                  }
                }
              </tidy-card-button>
            </tidy-card>
          }
        }
        @if (choseService() && !showMoreServices && (!showCategoryChooser || categoryId === 1)) {
          <tidy-row [align]="'center'" class="extra-bottom-padding">
            <tidy-text
              (action)="showServices()"
              [body]="'Show More Services'"
              class="white-link" />
          </tidy-row>
        }
        }
        @if (!isLoadingServiceDetail() && !isLoadingBookingForms && bookingForms?.length > 0) {
          <tidy-card>
            <dynamic-booking-form
              #dynamicBookingForm
              [forms]="bookingForms"
              [submitted]="submitted"
              [hasImageUploadError]="hasImageUploadError"
              [isLoading]="isLoadingDynamicForm"
              (attachmentsChange)="onAttachmentsChange($event)"
              (selectedCheckboxesChange)="onSelectedCheckboxesChange($event)"
              (formDataChange)="onFormDataChange($event)" />
          </tidy-card>
        }
        <tidy-row>
          <tidy-text
            [title]="moreTimesPerWeekSelected ? 'Select First Time' : 'Select Time'" />
        </tidy-row>
        @if (!isLoggingJob) {
          @if (isLoadingTimes) {
            <tidy-loader />
          }
          @if (!isLoadingTimes && !choseFrequency()) {
            <tidy-alert>
              <tidy-row [align]="'center'">
                <tidy-text
                  [body]="notChoseServiceSentence" />
              </tidy-row>
            </tidy-alert>
          }
          @if (!isLoadingTimes && choseService() && choseFrequency()) {
            @if (showRequestProSignal()) {
              <tidy-row class="extra-bottom-padding">
                <tidy-text
                  [body]="(selectedPro.viewValue | titlecase) + (' not available? ' | translate)" />
                <tidy-text
                  [body]="'Send them a request'"
                  class="white-link"
                  (action)="goToRequestPro()" />
              </tidy-row>
            }
            @if (showRequestJobSignal()) {
              <tidy-row>
                <tidy-text
                  [body]="'Don\'t see a time you like?'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="'Request time'"
                  class="white-link"
                  (action)="goToRequestJob()" />
              </tidy-row>
            }
            @if (!isLoadingTimes && noAvailableTimes() && !selectedPrivatePro()) {
              <tidy-alert>
                <tidy-row [align]="'center'">
                  <tidy-text
                    [header]="proNotBookableReason?.text | notBookableHeader:minRateToBookWithPro()" />
                </tidy-row>
                @if (proSelected()) {
                  <tidy-row [align]="'center'" [class.extra-bottom-padding]="!minRateToBookWithPro()">
                    <tidy-text
                      [body]="proNotBookableReason?.text" />
                    @if (proNotBookableReason?.request_eligible && !minRateToBookWithPro()) {
                      <tidy-text
                        [body]="' '" />
                      <tidy-text
                        [body]="'Request Job with'"
                        class="white-link"
                        (action)="goToRequestPro()" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="selectedPro.viewValue"
                        class="white-link"
                        (action)="goToRequestPro()" />
                    }
                  </tidy-row>
                }
                @if (minRateToBookWithPro()) {
                  <tidy-row>
                    @if (minRateToBookWithPro()) {
                      <tidy-button
                        [text]="('Change Rates to ' | translate) + (minRateToBookWithPro() | tcurrency)"
                        [action]="boundChangeServiceRates"
                        class="primary full-width" />
                    }
                  </tidy-row>
                  <tidy-row [align]="'center'" class="extra-bottom-padding">
                    <tidy-text
                      [body]="'You can also '" />
                    <tidy-text
                      [body]="('request a job with ' | translate) + selectedPro.viewValue"
                      class="white-link"
                      (action)="goToRequestPro()" />
                    <tidy-text
                      [body]="' and they may still accept at your current rates.'" />
                  </tidy-row>
                }
                @if (selectedPro?.value === 'all') {
                  <tidy-row [align]="'center'">
                    <tidy-text
                      [body]="'Unfortunately there is no availability in your area for this plan type.'" />
                  </tidy-row>
                }
                @if (selectedPro?.value !== 'all' && categoryId == 1) {
                  <tidy-row [align]="'center'">
                    <tidy-text
                      (action)="showAnyRatingFilter()"
                      [body]="'Click here'"
                      class="white-link" /><span>&nbsp;</span>
                    <tidy-text
                      [body]="'to view all of our availability.'" />
                  </tidy-row>
                }
              </tidy-alert>
            }
            @for (item of dateTimes(); track item; let idx = $index) {
              <tidy-card>
                @if (!selectedPrivatePro()) {
                  <tidy-row>
                    <tidy-text
                      [header]="item.date | parseDateTime:'dddd MMM d':''" />
                  </tidy-row>
                }
                @if (selectedPrivatePro()) {
                  <tidy-row class="field-top-padding extra-bottom-padding">
                    <form [formGroup]="form" novalidate action="#">
                      <tidy-select
                        [label]="'Select Date'"
                        [icon]="'assets/svg/calendar.svg'"
                        [form]="form.controls.privateDate"
                        formControlName="privateDate"
                        [items]="privateJobDates"
                        (optionChange)="changeDay($event)" />
                    </form>
                  </tidy-row>
                  @if (isLoadingPrivateTimes) {
                    <tidy-loader />
                  }
                  @if (!isLoadingTimes && !isLoadingPrivateTimes && item.times.length === 0) {
                    <tidy-row [align]="'center'">
                      <tidy-text
                        [body]="'No Times Available'" />
                    </tidy-row>
                  }
                }
                @if (!isLoadingTimes && !isLoadingPrivateTimes && !noAvailableTimes()) {
                  <tidy-row>
                    <form [formGroup]="form" novalidate action="#">
                      <tidy-radio-button
                        chunkSize="3"
                        formControlName="time"
                        (optionChange)="selectTime($event, idx)"
                        [form]="form.controls.time"
                        [(ngModel)]="form.value.time"
                        [items]="item.times" />
                    </form>
                  </tidy-row>
                }
              </tidy-card>
            }
            @if (!isLoadingTimes && !noAvailableTimes() && dateTimes()?.length && flowType !== 'private' && prosRatingsOptions?.length !== 1) {
              @if (categoryId == 1 && selectedPro?.viewValue !== '4.0+ Star Rating' && selectedPro?.viewValue !== 'Any Rating') {
                <tidy-row [align]="'center'">
                  <tidy-text
                    [body]="'Don\'t see a time you like?'" />
                </tidy-row>
                <tidy-row [align]="'center'">
                  <tidy-text
                    (action)="showAnyRatingFilter()"
                    [body]="'Click here'"
                    class="white-link" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="'to view all of availability.'" />
                </tidy-row>
              } @else {
                <tidy-row [align]="'center'">
                  <tidy-text
                    [body]="'Don\'t see a time you like?'" /><span>&nbsp;</span>
                  @if (showRequestJobSignal()) {
                    <tidy-text
                      [body]="'Request time'"
                      class="white-link"
                      (action)="goToRequestJob()" />
                  } @else {
                    <tidy-text
                      [body]="'Message Concierge'"
                      class="white-link"
                      (action)="goToContactConcierge()" />
                  }
                </tidy-row>
              }
            }
          }
        }
      }
    }
  </tidy-wrapper>
</ng-template>

<ng-template #rightColumn>
  @if (loaded && choseService() && windowService.isDesktopRes) {
    <tidy-wrapper class="custom-right-column right-side-content">
      <tidy-row [align]="'center'" style="margin-top: 10px;">
        <tidy-text
          [title]="(selectedService() | serviceLabel) | titlecase" />
      </tidy-row>
      @if (!configuration()?.hide_frequency && selectedFrequency()) {
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/refresh-circle.svg'"
            class="body-size" />
          <tidy-text
            [body]="selectedFrequency() | titlecase" />
        </tidy-row>
      }
      @if (selectedDuration) {
        @if (choseFrequency() || bookingExperiment() == 'consumer-control' || bookingExperiment() == 'rental-control') {
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/card.svg'"
              class="body-size" />
            <tidy-text
              [body]="displayPrice()" />
          </tidy-row>
        }
        @if (!isHourlyService()) {
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/time.svg'"
              class="body-size" />
            @if (selectedBillingType == 'hourly') {
              <tidy-text
                [body]="('Minimum ' | translate) + (selectedDuration | duration)" />
            }
            @if (selectedBillingType !== 'hourly') {
              <tidy-text
                [body]="selectedDuration | duration" />
            }
          </tidy-row>
        }
      }
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/svg/calendar.svg'"
          class="body-size" />
        <tidy-text
          [body]="dateLabel" />
      </tidy-row>
      @if ((form?.value?.frequency === 'twice_a_week' || form?.value?.frequency === 'thrice_a_week') && secondDateLabel) {
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/calendar.svg'"
            class="body-size" />
          <tidy-text
            [body]="secondDateLabel" />
        </tidy-row>
      }
      @if (form?.value?.frequency === 'thrice_a_week' && thirdDateLabel) {
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/calendar.svg'"
            class="body-size" />
          <tidy-text
            [body]="thirdDateLabel" />
        </tidy-row>
      }
      <tidy-button
        [text]="configuration()?.confirm_button_text"
        [action]="boundConfirmBooking"
        [disabled]="form.invalid"
        class="primary full-width" />
      @if (hasBookingFormError) {
        <tidy-row [align]="'center'">
          <tidy-error-message
            [text]="'Please fill out all required fields.'" />
        </tidy-row>
      }
      @if (showSavingsText) {
        <tidy-row style="margin-top: -5px" [align]="'center'">
          <tidy-text
            [smallBody]="savingsText()" />
        </tidy-row>
      }
    </tidy-wrapper>
  }
</ng-template>

@if (!isRightSideContent || !windowService.isDesktopRes) {
  <app-scroll-wrapper [style.padding-top.px]="topNavHeight" [showCardDesign]="true" [templateRightColumn]="rightColumn" [templateContent]="content" />
}

<ng-template #reviewBooking>
  <tidy-wrapper class="custom-right-column black-column small-padding-bottom">
    @if (loaded) {
      <div style="display: flex; justify-content: space-between; align-items: flex-start;">
        <div>
          <tidy-row class="vertical-align-center">
            <tidy-image
              class="body-size"
              [src]="'assets/img/icons/number_1_white.svg'" />
            <tidy-text
              [body]="serviceFrequencyLabelSignal() | titlecase" />
          </tidy-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              class="body-size"
              [src]="'assets/img/icons/number_2_white.svg'" />
            <tidy-text
              [body]="dateLabel" />
          </tidy-row>
          @if ((form?.value?.frequency === 'twice_a_week' || form?.value?.frequency === 'thrice_a_week') && secondDateLabel) {
            <tidy-row class="vertical-align-center">
              <tidy-image
                class="body-size"
                [src]="'assets/img/icons/number_3_white.svg'" />
              <tidy-text
                [body]="secondDateLabel" />
            </tidy-row>
          }
          @if (form?.value?.frequency === 'thrice_a_week' && thirdDateLabel) {
            <tidy-row class="vertical-align-center">
              <tidy-image
                class="body-size"
                [src]="'assets/img/icons/number_4_white.svg'" />
              <tidy-text
                [body]="thirdDateLabel" />
            </tidy-row>
          }
        </div>
        <div>
          @if (selectedDuration && selectedServiceData()) {
            <tidy-row class="extra-left-padding">
              @if (selectedServiceData()?.billingType !== 'price_later' && selectedServiceData()?.billingType !== 'hourly') {
                <tidy-text
                  [title]="displayPrice()"
                  class="text-price custom-text-price" />
              }
              @if (selectedServiceData()?.billingType == 'hourly' || selectedServiceData()?.billingType == 'price_later') {
                <tidy-text
                  [header]="displayPrice()"
                  class="text-price custom-text-price" />
              }
            </tidy-row>
          }
        </div>
      </div>
    }
    @if (loaded) {
      <tidy-button
        [text]="configuration()?.confirm_button_text"
        [action]="boundConfirmBooking"
        [disabled]="form.invalid"
        class="primary full-width" />
      @if (hasBookingFormError) {
        <tidy-row [align]="'center'">
          <tidy-error-message
            [text]="'Please fill out all required fields.'" />
        </tidy-row>
      }
      @if (showSavingsText) {
        <tidy-row [align]="'center'">
          <tidy-text
            [smallBody]="savingsText()"
            class="white" />
        </tidy-row>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (isRightSideContent && windowService.isDesktopRes) {
  <div class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="reviewBooking" />
  </div>
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
